// Exports beacon components which touch maplibre-gs wrapped in React Suspense to enable code splitting

import React, { type JSX, type ComponentProps, lazy, Suspense } from "react";

import Spinner from "../elements/Spinner";

const BeaconViewDialogComponent = lazy(() => import("./BeaconViewDialog"));

export function BeaconViewDialog(props: ComponentProps<typeof BeaconViewDialogComponent>): JSX.Element {
    return (
        <Suspense fallback={<Spinner />}>
            <BeaconViewDialogComponent {...props} />
        </Suspense>
    );
}
